<template>
  <div class="">
    <div class="introduce"
      :style="{ 'color': text_color }">
      <course-introduce-block :title="'課程介紹'"
        v-bind:icon="getCourseImageSrc(assets_path, 'page_ICON_1.png')"
        v-bind:header_color="header_color"
        v-bind:bottom_color="bottom_color"
        v-bind:info="course == null ? '' : course.introduce"></course-introduce-block>
      <course-introduce-block :title="'課程學習目標'"
        v-bind:icon="getCourseImageSrc(assets_path, 'page_ICON_2.png')"
        v-bind:header_color="header_color"
        v-bind:bottom_color="bottom_color"
        v-bind:item_type="course == null ? 'text' : getDataType(course.objectives)"
        v-bind:info="course == null ? '' : course.objectives"></course-introduce-block>
      <!-- <course-introduce-block :title="'課程學習進度'"
        v-if="false"
        :icon="getCourseImageSrc(assets_path, 'page_ICON_3.png')"
        :header_color="header_color"
        :item_type="'weekly'"
        :play_icons="play_icons"
        :read_icons="read_icons"
        :info="course == null ? null : course"></course-introduce-block> -->
      <part-list
        ref="partList"
        v-bind:title="parts_section_title"
        v-bind:icon="getCourseImageSrc(assets_path, 'page_ICON_3.png')"
        v-bind:header_color="header_color"
        v-bind:item_type="'weekly'"
        v-bind:assets_path="course == null ? '' : course['assets_path']"
        v-bind:current_course="course == null ? null : course"
        ></part-list>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  import VueCourseIntroduceBlock from './CourseIntroduceBlock'
  import VuePartList from './PartList'
  import { globalMixin, courseMixin } from './_Mixins'

  export default {

    data() {
      return {
        //course: null,
      }
    },
    //props: [ 'course' ],

    components: {
      'CourseIntroduceBlock': VueCourseIntroduceBlock,
      'PartList': VuePartList,
    },

    mounted() {
      let _this = this
    },

    mixins: [ globalMixin, courseMixin ],

    methods: {
      getColors() {
        if (!this.course) return

        if (!this.course['colors']) return

        return this.course.colors
      },

      getDataType(data) {
        if (Array.isArray(data)) {
          return 'list'
        }
        return 'text'
      }
    },

    computed: {
      parts_section_title() {
        if (this.course) {
          if (this.getAttribute(this.course, 'custom-parts-section-title') != '') {
            let customPartsSectionTitle = this.course['custom-parts-section-title']

            return customPartsSectionTitle
          }

          return this.is_topic ? '系列講題' : '課程學習進度'
        }

        return ''
      },
      is_topic() {
        if (this.course) {
          if (!this.course['course_type']) return false
          if (this.course['course_type'] == 'topic') return true
        }

        return false
      },

      settings() {

        console.log('@@@ CourseIntroduce.vue > settings : this.course : ', this.course)

        var data = {
          'intro': '',
          'objectives': '',
          'icons': {
            'icon-1': '',
            'icon-2': '',
            'icon-3': '',
          },
          'text_color': this.text_color,
          'header_color': this.header_collor,
          'bottom_color': this.bottom_color,
          'play_icons': this.play_icons,
          'read_icons': this.read_icons,
          'item_type': this.item_type,
        }

        if (this.course) {
          let colors = this.getColors()

          console.log('@@@ CourseIntroduce.vue > settings : this.course : ', this.course)

          data = {
            'intro': this.getAttribute('introduce'),
            'objectives': this.getAttribute('objectives'),
            'icons': {
              'icon-1': this.getCourseImageSrc(this.assets_path, 'page_ICON_1.png'),
              'icon-2': this.getCourseImageSrc(this.assets_path, 'page_ICON_2.png'),
              'icon-3': this.getCourseImageSrc(this.assets_path, 'page_ICON_3.png'),
            },
            'text_color': colors == null ? '#ffffff' : colors.text,
            'header_color': colors == null ? '#ffffff' : colors.section.header,
            'bottom_color': colors == null ? '#ffffff' : colors.section.bottom,
            'play_icons': this.play_icons,
            'read_icons': this.read_icons,
            'item_type': this.item_type,
          }
        }

        console.log('CourseIntroduce.vue > settings : ', data)

        return data
        /*
        'prefix',
        'title',
        'info',
        'icon',
        'header_color',
        'bottom_color',
        'play_icons',
        'read_icons',
        'item_type'
        */
      },

      assets_path() {
        if (!this.course) return ''

        if (!this.course['assets_path']) return ''

        return this.course.assets_path
      },

      header_color() {
        let colors = this.getColors()

        if (!colors) return '#ffffff'

        return colors.section.header
      },

      bottom_color() {
        let colors = this.getColors()

        if (!colors) return '#ffffff'

        return colors.section.bottom
      },

      text_color() {
        let colors = this.getColors()

        if (!colors) return '#ffffff'

        return colors.text
      },

      play_icons() {
        let icons = {
          over: '',
          i_01: '',
          i_02: '',
        }

        if (!this.course) {
          return icons
        }

        icons.over = this.getCourseImageSrc(this.assets_path, 'page_PLAY_over.png')
        icons.i_01 = this.getCourseImageSrc(this.assets_path, 'page_PLAY01.png')
        icons.i_02 = this.getCourseImageSrc(this.assets_path, 'page_PLAY02.png')

        return icons
      },

      read_icons() {
        let icons = {
          over: '',
          i_01: '',
          i_02: '',
        }

        if (!this.course) {
          return icons
        }

        icons.over = this.getCourseImageSrc(this.assets_path, 'page_READ_over.png')
        icons.i_01 = this.getCourseImageSrc(this.assets_path, 'page_READ01.png')
        icons.i_02 = this.getCourseImageSrc(this.assets_path, 'page_READ02.png')

        return icons
      },

      objective_type() {
        if (!this.course) return 'text'

        if (Array.isArray(this.course.objectives)) {
          return 'list'
        }

        return 'text'
      },

    },

    watch: {
      getCurrentCourse: async function(promise) {
          //console.log('Course.vue', 'watch', 'getCurrentCourse : ', value)

          // let _course = await promise
          // this.course = _course

          // // console.log('CourseIntroduce.vue', 'watch', 'course', this.course)
          // this.$refs.partList.course = _course

      },
      course: function(value) {
        if (value) {
          console.log('CourseIntroduce.vue > watch > course : ', value)
        }
      }
    }

  }

</script>



// WEBPACK FOOTER //
// src/components/CourseIntroduce.vue